import React, { FC } from 'react';
import styled from 'styled-components/macro';
import media from 'styles/media';
import * as MESSAGES from 'constants/messages';
import { Card, ButtonS } from 'components/atoms';
import { ProfileGroupLabel } from 'components/molecules';
import { ProfileFormItems } from 'types/profile';
import useProfile from '../useProfile';
import NewGraduateProfileExperiencesContents from './NewGraduateProfileExperiencesContents';
import NewGraduateProfileExperiencesForm from './NewGraduateProfileExperiencesForm';
import { UpdateProfileCompletedModal } from '../Modals';

const Wrapper = styled.div`
  width: 100%;
`;

const ContentHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
  margin-bottom: 16px;

  ${media.mobile} {
    margin-bottom: 12px;
  }
`;

const ContentCard = styled(Card)`
  width: 100%;
`;

type NewGraduateProfileExperiencesProps = {
  formItems: ProfileFormItems;
};

const NewGraduateProfileExperiences: FC<NewGraduateProfileExperiencesProps> = props => {
  const { formItems } = props;
  const {
    canEdit,
    isEdit,
    handleShowContent,
    handleShowEdit,
    showUpdateProfileCompletedModal,
    openUpdateProfileCompletedModal,
    closeUpdateProfileCompletedModal,
  } = useProfile();

  return (
    <>
      <Wrapper>
        <ContentHead>
          <ProfileGroupLabel
            label={
              MESSAGES.PROFILE_SETTING.NEW_GRADUATE_PROFILE_EXPERIENCES.LABEL
            }
            showInformation={isEdit}
          />

          {canEdit && !isEdit && (
            <ButtonS
              onClick={handleShowEdit}
              data-testid="button-edit-new-graduate-experiences"
            >
              {MESSAGES.PROFILE_SETTING.BUTTON.EDIT}
            </ButtonS>
          )}
        </ContentHead>
        <ContentCard>
          {isEdit ? (
            <NewGraduateProfileExperiencesForm
              formItems={formItems}
              onShowContent={handleShowContent}
              onOpenCompletedModal={openUpdateProfileCompletedModal}
            />
          ) : (
            <NewGraduateProfileExperiencesContents />
          )}
        </ContentCard>
      </Wrapper>

      <UpdateProfileCompletedModal
        show={showUpdateProfileCompletedModal}
        onClose={closeUpdateProfileCompletedModal}
      />
    </>
  );
};

export default NewGraduateProfileExperiences;
